// Projects when a goal mile time is reached from logged time-trials, via a simple
// least-squares trend. Honest: needs >=2 points; returns null otherwise.

export function projectGoal(points, goalSec) {
  if (!points || points.length < 2) return null;
  const n = points.length;
  const sx = points.reduce((a, p) => a + p.daysFromStart, 0);
  const sy = points.reduce((a, p) => a + p.mileSec, 0);
  const sxx = points.reduce((a, p) => a + p.daysFromStart ** 2, 0);
  const sxy = points.reduce((a, p) => a + p.daysFromStart * p.mileSec, 0);
  const denom = n * sxx - sx * sx;
  if (denom === 0) return { improving: false, daysToGoal: null, slope: 0 };
  const slope = (n * sxy - sx * sy) / denom; // sec/day; negative = getting faster
  const latest = points[points.length - 1];
  const improving = slope < -0.05;
  if (!improving) return { improving: false, daysToGoal: null, slope };
  const daysToGoal = Math.max(0, Math.round((latest.mileSec - goalSec) / -slope));
  return { improving: true, daysToGoal, slope };
}
